import {BaseConnection} from './BaseConnection';

export class MailConnection extends BaseConnection {
authRequired: boolean | null;
tlsRequired: boolean | null;
}

